import { ComponentProps } from 'react';
import { TransactionId } from 'vopay';
import ReversalTransactionInfo from './ReversalTransactionInfo';

type ReversalTransactionContainerProps = TransactionId &
  Omit<ComponentProps<typeof ReversalTransactionInfo>, 'TransactionId'>;

export default function ReversalTransactionContainer({
  TransactionID,
  jwt,
  ...props
}: ReversalTransactionContainerProps) {
  return <div>{TransactionID && <ReversalTransactionInfo TransactionId={TransactionID} jwt={jwt} {...props} />}</div>;
}
